import { styled } from '@mui/material/styles';
import { Box, Typography, Paper, Tabs, Tab, Grid, TextField, Button } from '@mui/material';

export const PageWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: '#F8F9FA',
  minHeight: '100vh',
}));

export const HeaderCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: '12px',
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(3),
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
  position: 'relative',
}));

export const IconWrapper = styled(Box)(({ theme }) => ({
  width: '64px',
  height: '64px',
  borderRadius: '12px',
  backgroundColor: '#F0F0F0',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginRight: theme.spacing(3),
}));

export const HeaderInfo = styled(Box)({
  flex: 1,
});

export const StatusBadge = styled(Box)<{ status: string }>(({ status }) => ({
  padding: '4px 12px',
  borderRadius: '4px',
  fontSize: '12px',
  fontWeight: 600,
  display: 'inline-block',
  marginLeft: '12px',
  backgroundColor: (status === 'Approved' || status === 'approved') ? '#E8F5E9' : '#FFF3E0',
  color: (status === 'Approved' || status === 'approved') ? '#2E7D32' : '#E65100',
}));

export const SuspendedTag = styled(Box)({
  position: 'absolute',
  top: '24px',
  right: '24px',
  padding: '4px 12px',
  borderRadius: '4px',
  fontSize: '10px',
  fontWeight: 600,
  color: '#D32F2F',
  border: '1px solid #D32F2F',
  textTransform: 'lowercase',
});

export const ContentPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(0),
  borderRadius: '12px',
  overflow: 'hidden',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
}));

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  padding: theme.spacing(0, 3),
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  '& .MuiTabs-indicator': {
    backgroundColor: '#5E8E7E',
    height: '3px',
  },
}));

export const StyledTab = styled(Tab)({
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '13px',
  minWidth: 'auto',
  marginRight: '32px',
  padding: '20px 0',
  color: '#999',
  '&.Mui-selected': {
    color: '#5E8E7E',
  },
});

export const TabPanelContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
}));

export const DetailsSection = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2, 3),
  borderRadius: '12px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#F8F9FA',
  },
}));

export const SectionHeader = styled(Box)(({ theme }) => ({
  backgroundColor: '#5E8E7E',
  padding: theme.spacing(1, 2),
  marginBottom: theme.spacing(3),
}));

export const SectionTitle = styled(Typography)({
  color: '#fff',
  fontSize: '16px',
  fontWeight: 600,
});

export const DetailRow = styled(Grid)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const Label = styled(Typography)({
  fontSize: '12px',
  color: '#666',
  fontWeight: 500,
  marginBottom: '4px',
});

export const Value = styled(Typography)({
  fontSize: '14px',
  color: '#333',
  fontWeight: 500,
});

export const DocumentGrid = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(1),
}));

export const DocsContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1.5),
  width: '100%',
  padding: theme.spacing(2),
  backgroundColor: '#F9FAFB',
  borderRadius: '10px',
  border: '1px solid #E5E7EB',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  transition: 'all 0.2s ease',
  '&:hover': {
    backgroundColor: '#F3F4F6',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.03)',
  },
}));

export const DocIconBox = styled(Box)(({ theme }) => ({
  width: '44px',
  height: '44px',
  borderRadius: '8px',
  backgroundColor: '#fff',
  border: '1px solid #E5E7EB',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginRight: theme.spacing(2),
  color: '#6B7280',
}));

export const DateContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginRight: theme.spacing(3),
  gap: '8px',
}));

export const DateTextField = styled(TextField)(({ theme }) => ({
  width: '180px',
  margin: theme.spacing(0, 1),
  '& .MuiOutlinedInput-root': {
    borderRadius: '4px',
    backgroundColor: '#fff',
    '& input': {
      textAlign: 'center',
      padding: '8px 12px',
      fontSize: '0.9rem',
    },
    '& fieldset': {
      borderColor: '#e0e0e0',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#5E8E7E',
    },
  },
}));

export const DocumentExpiring = styled(Box)(({ theme }) => ({
  backgroundColor: '#E57373',
  color: '#fff',
  padding: theme.spacing(1, 2),
  fontSize: '0.875rem',
  fontWeight: 'bold',
  width: "100%",
  marginTop: theme.spacing(2),
  borderRadius: '4px',
}));

export const FileIconWrapper = styled(Box)({
  width: '40px',
  height: '40px',
  borderRadius: '6px',
  backgroundColor: '#F5F5F5',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

// Facilities Tab Styles
export const SummaryCardsGrid = styled(Grid)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const MetricCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: '12px',
  display: 'flex',
  alignItems: 'center',
  backgroundColor: '#fff',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
}));

export const MetricIconBox = styled(Box)<{ bgColor: string }>(({ bgColor }) => ({
  width: '48px',
  height: '48px',
  borderRadius: '12px',
  backgroundColor: bgColor,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginRight: '16px',
}));

export const FilterSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(3),
  gap: theme.spacing(2),
}));

export const SearchField = styled(TextField)({
  width: '300px',
  '& .MuiOutlinedInput-root': {
    height: '40px',
    borderRadius: '8px',
    backgroundColor: '#fff',
  },
});

export const StatusTabs = styled(Tabs)(({ theme }) => ({
  minHeight: 'auto',
  marginBottom: theme.spacing(2),
  '& .MuiTabs-indicator': {
    backgroundColor: '#5E8E7E',
    height: '3px',
  },
}));

export const StatusTab = styled(Tab)({
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '14px',
  minWidth: 'auto',
  padding: '12px 16px',
  color: '#999',
  '&.Mui-selected': {
    color: '#5E8E7E',
  },
});

export const StyledTableContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#fff',
  borderRadius: '8px',
  overflow: 'hidden',
  '& table': {
    width: '100%',
    borderCollapse: 'collapse',
  },
  '& th': {
    backgroundColor: '#5E8E7E',
    color: '#fff',
    textAlign: 'left',
    padding: theme.spacing(1.5, 2),
    fontSize: '13px',
    fontWeight: 600,
  },
  '& td': {
    padding: theme.spacing(2),
    fontSize: '13px',
    borderBottom: '1px solid #f0f0f0',
    color: '#333',
    fontWeight: 500,
  },
  '& tr:nth-of-type(even)': {
    backgroundColor: '#FAFAFA',
  },
}));

export const StatusPill = styled(Box)<{ status: string }>(({ status }) => ({
  padding: '4px 12px',
  borderRadius: '4px',
  fontSize: '11px',
  fontWeight: 600,
  display: 'inline-block',
  textTransform: 'uppercase',
  backgroundColor: status === 'active' || status === 'ACTIVE' ? '#E8F5E9' : status === 'pending' || status === 'PENDING' ? '#FFF3E0' : '#FFEBEE',
  color: status === 'active' || status === 'ACTIVE' ? '#2E7D32' : status === 'pending' || status === 'PENDING' ? '#E65100' : '#C62828',
}));

export const ActionButton = styled(Button)<{ $actionType: 'take' | 'none' }>(({ $actionType }) => ({
  textTransform: 'none',
  fontSize: '11px',
  fontWeight: 600,
  padding: '4px 12px',
  borderRadius: '4px',
  minWidth: '120px',
  backgroundColor: $actionType === 'take' ? '#F5E6CC' : '#F0F0F0',
  color: $actionType === 'take' ? '#8D6E63' : '#999',
  '&:hover': {
    backgroundColor: $actionType === 'take' ? '#EBD9B4' : '#E8E8E8',
  },
}));

export const FilterRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(3),
}));

export const ButtonGroupContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: theme.spacing(2),
}));

export const VerificationImageContainer = styled(Grid)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '& img': {
    width: '40px',
    height: '40px',
  }
}));

export const ActionCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: '12px',
  marginTop: theme.spacing(3),
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
  backgroundColor: '#fff',
}));
